import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import { useI18n } from "../lib/i18n";
import api, { formatApiErrorDetail } from "../lib/api";
import { AuthField } from "./Login";

export default function ResetPassword() {
    const { t } = useI18n();
    const [params] = useSearchParams();
    const nav = useNavigate();
    const token = params.get("token") || "";
    const [password, setPassword] = useState("");
    const [done, setDone] = useState(false);
    const [error, setError] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setBusy(true);
        try {
            await api.post("/auth/reset-password", { token, new_password: password });
            setDone(true);
            setTimeout(() => nav("/login"), 1500);
        } catch (err) {
            setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="bg-grain min-h-screen">
            <Navbar />
            <div className="max-w-md mx-auto px-4 py-20" data-testid="reset-page">
                <h1 className="font-display text-4xl">{t.auth.resetTitle}</h1>
                <p className="text-brand-text/70 mt-2">{t.auth.resetSub}</p>
                {done ? (
                    <div className="mt-8 rounded-3xl border border-brand-border bg-white p-7 text-center space-y-2" data-testid="reset-done">
                        <div className="text-brand-success font-semibold">{t.auth.resetDone}</div>
                        <Link to="/login" className="text-brand-primary text-sm">→ {t.auth.login}</Link>
                    </div>
                ) : (
                    <form onSubmit={submit} className="mt-8 space-y-4 rounded-3xl border border-brand-border bg-white p-7">
                        <AuthField label={t.auth.newPassword} type="password" value={password} onChange={setPassword} testid="reset-password-input" required />
                        {error && <div className="text-sm text-brand-critical" data-testid="reset-error">{error}</div>}
                        <button disabled={busy || !token} type="submit" className="w-full py-3 rounded-full btn-primary font-semibold disabled:opacity-60" data-testid="reset-submit">
                            {busy ? "..." : t.auth.resetCta}
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
}
